var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCollapseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "red",
    d: "M43.918 24C43.918 35 35 43.918 24 43.918S4.082 35 4.082 24 13 4.082 24 4.082 43.918 13 43.918 24zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D2D2D2",
    d: "M24 43.918C13.02 43.918 4.082 34.98 4.082 24 4.082 13.02 13.02 4.082 24 4.082c10.98 0 19.918 8.938 19.918 19.918 0 10.98-8.938 19.918-19.918 19.918zm0-38.461C13.773 5.457 5.457 13.773 5.457 24c0 10.227 8.316 18.543 18.543 18.543 10.227 0 18.543-8.316 18.543-18.543 0-10.227-8.316-18.543-18.543-18.543zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "green",
    d: "M32.656 25.441H15.344a1.44 1.44 0 110-2.882h17.312a1.44 1.44 0 110 2.882zm0 0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollapseIcon);
export default __webpack_public_path__ + "static/media/CollapseIcon.6a3be88ee6033914deb42c450e55f4ab.svg";
export { ForwardRef as ReactComponent };